/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Solid_Color_LabelInputs */



/**
* | output |
* | --- |
* | "Solid Color (for keying)" |
*
* @param {Image_Export_Solid_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_solid_color_label = /** @type {((inputs?: Image_Export_Solid_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Solid_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur unie (pour le keying)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Volltonfarbe (für die Kennzeichnung)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore pieno (per la codifica)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сплошной цвет (для ключа)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color sólido (para codificación)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("纯色（用于抠像）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単色（キーイング用）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठोस रंग (कीबोर्डिंग के लिए)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor sólida (para chaveamento)")
	return /** @type {LocalizedString} */ ("Solid Color (for keying)")
});